import React from 'react';
import ZFlixSplashLogo from './ZFlixSplashLogo';

export default function SplashCinematic({ reducedMotion = false }) {
  return (
    <div className={`zflix-splash-stage zflix-splash-cinematic${reducedMotion ? ' zflix-splash-stage--static' : ''}`}>
      <div className="zflix-splash-cinematic-vignette" aria-hidden />
      <div className={reducedMotion ? '' : 'zflix-splash-cinematic-zoom'}>
        <ZFlixSplashLogo size="large" />
      </div>
      <p className="zflix-splash-cinematic-tagline">Your library. Your couch. Let&apos;s roll.</p>
    </div>
  );
}
